import s from './agenda.module.css'

export default function Agenda({ title, items }) {
	if (items && items.length > 0) {
		return (
			<div className={s.agenda}>
				<h4>{title ? title : 'Agenda'}</h4>
				<ul className={s.table}>
					{items.map(({ timeSlot, description }) => (
						<li className={s.item} key={timeSlot}>
							<span className={`g-type-body-small ${s.timeSlot}`}>
								{timeSlot}
							</span>
							<span className={`g-type-display-6 ${s.description}`}>
								{description}
							</span>
						</li>
					))}
				</ul>
			</div>
		)
	}

	return null
}
